import React, { PureComponent } from "react";
import ShareOfVoiceWithSubtopicsChart from "./ShareOfVoiceWithSubtopicsChart";
import { connect } from "react-redux";
import { Icon, Dropdown } from "semantic-ui-react";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import NoData from "../NoData/NoData";
import html2canvas from "html2canvas";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DimmerComponent from "../../DimmerComponent";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/downloads.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { showChartsDrilldown } from "../../../../../actions/dashboardAction";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import IntervalSelector from "../IntervalSelector";
import moment from "moment-timezone";
import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import * as d3 from "d3";
class ShareOfVoiceWithSubTopics extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
            showGridLines: false,
        };
        this.chartEl = React.createRef();
    }
    componentDidUpdate(prevProps) {
        // if (prevProps.graph_type !== this.props.graph_type && this.props.graph_type === "line" && this.props.data && !this.props.data.hasLineData) {
        //     this.props.changeGraphType("line", true);
        // }
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                self.handleDrilldownClick(chart);
                // this.props.showChartsDrilldown(true, "shareOfVoiceSubTopicWiseBreakDown");
            });

        contextMenu.style("display", "block");
    };

    createNewFilter(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        if (this.props.graph_type === "pie") {
            if (d.options.allSubtopicSelected === "others") {
                newFilter.subtopics = d.options.subtopicIds;
                newFilter.topics = [];
            } else {
                newFilter.topics = [];
                newFilter.subtopics = [d.options.subtopicId];
            }
        } else if (this.props.graph_type === "bar") {
            if (d.series.userOptions.allSubtopicSelected === "others") {
                newFilter.subtopics = d.series.userOptions.subtopicIds;
                newFilter.topics = [];
            } else {
                newFilter.topics = [];
                newFilter.subtopics = [d.series.userOptions.subtopicId];
            }
        } else if (this.props.graph_type === "line") {
            if (d.series.userOptions.allSubtopicSelected === "others") {
                newFilter.subtopics = d.series.userOptions.subtopicIds;
                newFilter.topics = [];
            } else {
                newFilter.topics = [];
                newFilter.subtopics = [d.series.userOptions.subtopicId];
            }
            let lastComparisonIndex = false;
            lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("55");
            newFilter = getViewConversationDuration(
                d,
                newFilter,
                this.props.aggs_val,
                this.props.filters,
                this.props.comparisionData,
                lastComparisonIndex,
                this.props.comparisonAppliedFilter,
            );
        }
        return newFilter;
    }

    handleContextMenuClick = (chart) => {
        let newFilter = this.createNewFilter(chart);
        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(chart) {
        let newFilter = this.createNewFilter(chart);
        this.props.handleDrilldownClick(newFilter);
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [];
        let comparisonCsvFmt;
        if (this.props.graph_type === "line") {
            let userTz = JSON.parse(localStorage.getItem("company")).user_timezone_name;
            csvFmt = [["Time"]];
            this.props.data.csvLineData[0].data.forEach((d) => {
                csvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
            });
            this.props.data.csvLineData.forEach((t) => {
                csvFmt[0].push(t.name);
                t.data.forEach((d, i) => {
                    csvFmt[i + 1].push(d.y);
                });
            });

            if (this.props.comparisionData && this.props.comparisionData.csvLineData[0].data) {
                comparisonCsvFmt = [[" Comparison Time"]];
                let topic = this.props.comparisionData.csvLineData[0].data;
                this.props.comparisionData.csvLineData[0].data.forEach((d) => {
                    comparisonCsvFmt.push([moment(d.x).tz(userTz).format("YYYY-MM-DD HH:mm")]);
                });
                this.props.comparisionData.csvLineData.forEach((t) => {
                    comparisonCsvFmt[0].push(t.name);
                    t.data.forEach((d, i) => {
                        comparisonCsvFmt[i + 1].push(d.y);
                    });
                });

                csvFmt.push(...comparisonCsvFmt);
                let firstIndLen = csvFmt[0].length;
                let lastIndLen = csvFmt[csvFmt.length - 1].length;

                let length;
                if (firstIndLen > lastIndLen) length = firstIndLen;
                else length = lastIndLen;

                let arr = [];
                for (let i = 0; i < length; i++) {
                    arr.push([]);
                    for (let j = 0; j < csvFmt.length; j++) {
                        if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                        else arr[i].push(0);
                    }
                }
                csvFmt = arr;
            }
        } else {
            csvFmt.push(["Subtopic Name", "Count"]);
            let csvData = this.props.data.csvData;
            csvData.forEach((ele, ind) => {
                csvFmt.push([ele.name, ele.y]);
            });
            csvFmt.push(["Total", this.props.data.total]);
        }
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    downloadPNG = (options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        this.setState({ downloading: true });
        html2canvas(this.chartEl.current, { backgroundColor: options ? "#fff" : null }).then((canvas) => {
            this.setState({ downloading: false });
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    renderDownloadButton(nodata) {
        return (
            <Dropdown
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    <Dropdown.Item onClick={this.downloadCSV}>CSV</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(true)}>PNG</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.downloadPNG(false)}>PNG(Transparent)</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }
    changeGraphType = (val) => {
        let makeApiCall = val === "line" && ["bar", "pie"].includes(this.props.graph_type) && !this.props.data.hasLineData;
        this.props.changeGraphType(val, makeApiCall);
    };
    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;
        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName name={this.props.widget.name} info="Share of Voice with subtopic wise breakdown." />
                    <div className="dashboard-widget-actions">
                        {!nodata && (
                            <div className="chart-type">
                                <span onClick={() => this.props.changeGraphType("pie")} className={this.props.graph_type === "pie" ? "active-chart" : ""}>
                                    <Icon name="pie chart" />
                                </span>
                                <span onClick={() => this.props.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Icon name="bar chart" />
                                </span>
                                <span onClick={() => this.changeGraphType("line")} className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Icon name="line chart" />
                                </span>
                            </div>
                        )}
                        {!this.props.isResearchDashboard &&
                            this.props.graph_type !== "pie" &&
                            this.props.graph_type !== "bar" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar showMoreOptionsLoc={this.props.showMoreOptionsLoc} changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && this.props.graph_type !== "line" && (
                            <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />
                        )}
                        {!nodata && <CustomCheckBox checked={this.props.showLegendBar} onClick={this.props.changeShowLegendBar} label="Show Legends" />}
                        {!nodata && this.props.graph_type !== "pie" && (
                            <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />
                        )}
                        {!nodata && this.props.graph_type === "line" && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        <ShareOfVoiceWithSubtopicsChart
                            data={this.props.data}
                            showGridLines={this.props.showGridLines}
                            addContextMenuListener={this.addContextMenuListener}
                            showLabel={this.props.showLabel}
                            showLegend={this.props.showLegendBar}
                            widgetContainerRef={this.props.widgetContainerRef}
                            currentChartType={this.props.graph_type}
                            resizedCount={this.props.resizedCount}
                            comparisionData={this.props.comparisionData}
                        />
                        {this.state.downloading && <DimmerComponent />}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}
function mapStateToProps(state) {
    return {
        allTopics: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.topics : [],
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showChartsDrilldown: (bool, name) => dispatch(showChartsDrilldown(bool, name)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareOfVoiceWithSubTopics);
